import serviceTaskRunner, { services, _callRestfulService as restful } from "../lib/restful/services/restAPIs";
import { CryptoTransform } from "../lib/util/ClientUtil";
import { SeqCrypto } from "../lib/util/SeqCrypto";
import {
  getUrlImageType,
  resizeImageDataString,
  base64ToFile,
  reduceImageResolution,
  reduceImageResolutionByHeight,
  reduceFileImageResolution
} from "../utils/common";
import { v4 as uuid } from "uuid";
import sessionData from "../lib/session/sessionData.json"
import { ClientMediator } from '@8d-xyz/ui-react_application_f-container';
import { cleanUpTempValues } from "../lib/util/Util";   
export const ACCESS_AUTHEN  = async (values, grantAccess, setIsLoading) => {
  //console.log("Login submitted:", values);
  cleanUpTempValues(values);
  let authenticated = false;
  setIsLoading((prev)=>true);
  let _SignInTaskRunner = await serviceTaskRunner(services.ACCESS_AUTHEN)(
    values, {},
    async (response, callParams) => {
      //callBack function
      //Get return data from the restufl call
      const data = response.data.payload;
      let result = data;
      grantAccess(data);
      authenticated=true;
      return result;
    },
    {
      //callBack Parameters
    },
    (error) => {
      //console.log(error);
      setIsLoading((prev)=>false);
      throw { message: "Unable to authenticate access" };
    }
  );

  //console.log(_SignInTaskRunner);
  setIsLoading((prev)=>false);
  return authenticated;

};            
export const ACCESS_REFRESH  = async () => {
  let result = null;
  let _SignInTaskRunner = await serviceTaskRunner(services.ACCESS_REFRESH)(
    {}, {},
    async (response, callParams) => {
      const data = response.data.payload;
      result = data;
      return result;
    },
    {
      //callBack Parameters
    },
    (error) => {
      console.log(error);
      throw { message: "Unable to refresh token" };
    }
  );
  return result;
};    


export const LOGIN  = async (values, login, setIsLoading) => {
  //console.log("Login submitted:", values);
  cleanUpTempValues(values);
  let authenticated = false;
  setIsLoading((prev)=>true);
  let _SignInTaskRunner = await serviceTaskRunner(services.SIGN_IN)(
    values, {},
    async (response, callParams) => {
      //callBack function
      //Get return data from the restufl call
      const data = response.data.payload;
      let result = data;
      authenticated=true;
      //const authToken = 'example-token';
      //const userData = { name: 'John Doe', email };
      login(data, data.idToken);
      //throw "fock"  //show in the widget
      //do something
      return result;
    },
    {
      //callBack Parameters
    },
    (error) => {
     
      //console.log(error);
      setIsLoading((prev)=>false);
      throw { message: "Unable to authenticate user" };

    }
  );

  //console.log(_SignInTaskRunner);
  setIsLoading((prev)=>false);
  return authenticated;

};

export const SIGNUP = async (values, login, setIsLoading) => {
  //console.log("Sign-up submitted:", values);
  cleanUpTempValues(values);
  let _SignUpTaskRunner = await serviceTaskRunner(services.SIGN_UP)(
    values, {},
    async (response, callParams) => {
      //callBack function
      //Get return data from the restufl call
      const data = response.data.payload;
      let result = data;

      login(data, data.idToken);

      return result;
    },
    {
      //callBack Parameters
    },
    (error) => {
      //console.log(error)
      throw { message: "Unable to create user account." };
    }
  );
  return true;
};


export const PASSWORD_RESET = async (values,setIsLoading) => {
  //console.log("Password recovery requestedxxxx:", values);
  //alert(setIsLoading);
  cleanUpTempValues(values);
  setIsLoading(true);
  let _AccountRecoverTaskRunner = await serviceTaskRunner(services.ACCOUNT_RECOVER)(
    values,{},
    async (response, callParams) => {
        //callBack function
        //Get return data from the restufl call
        const data = response.data.payload;
       // console.log(data)
        // if(Object.keys(data).length === 0) {
        //   throw {message:"email not recognized"}
        // };
        //do something
        return data;
    },
    {
    //callBack Parameters
    },
    (error)=>{
      //console.log("ofuck")
      setIsLoading(false);
     // return true;
      throw error
    }
    );
    setIsLoading(false);
  return true;
};